'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var material = require('@mui/material');
var createFieldControl = require('../lib/form/createFieldControl.js');

const FIELD_HEADING_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldHeading on Field_Heading {
    __typename
    ...fieldBase
  }
`);
const Field_Heading = createFieldControl.createField(FIELD_HEADING_FRAGMENT, (field, _props)=>{
    return /*#__PURE__*/ jsxRuntime.jsx(material.Typography, {
        variant: "h4",
        children: field.label
    });
});

exports.FIELD_HEADING_FRAGMENT = FIELD_HEADING_FRAGMENT;
exports.Field_Heading = Field_Heading;
